import React from "react";
import folder from "../assets/folder.svg";

const Folder = ({ title, desc, icon }) => {
  return (
    <div className="flex flex-col items-center gap-3 w-full h-full mx-auto my-5">
      {/* Folder Card with icon centered */}
      <div
        className="relative w-full md:h-60 h-36 bg-no-repeat bg-contain bg-center"
        style={{ backgroundImage: `url(${folder})` }}
      >
        <div className="absolute inset-0 flex flex-col justify-center items-center">
          <img src={icon} alt="Icon" className="w-12 h-12 md:h-32 md:w-32 object-contain" />
          {/* Title */}
          <h1 className="text-[#282828] text-sm md:text-xl font-semibold text-center">
            {title}
          </h1>
        </div>

      </div>



      {/* Description */}
      {/* <p className="text-[#282828] text-sm text-center">
        {desc}
      </p> */}
    </div>
  );
};

export default Folder;
